module.exports = __webpack_public_path__ + "static/img/news_title.d0f4f30.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/news_title.png
// module id = 0z8q
// module chunks = 0